import { uniq } from 'lodash';

export const isAnonomizedEmail = (email?: string): boolean => {
	if (!email) {
		return false;
	}

	return email.startsWith('anonimized');
}

export const sanitizeEmailRecipients = (recipients: string | string[] | undefined): string[] => {
	if (!recipients) {
		return [];
	}

	const res = Array.isArray(recipients) ? uniq(recipients) : [recipients];

	return res.filter(email => !isAnonomizedEmail(email) && Boolean(email));
}
